import { useTranslations } from '@vocab/react';
import { Button, HiddenVisually } from 'braid-design-system';
import React, { type FunctionComponent, type ReactNode } from 'react';

import translations from '../../../.vocab';

interface DeleteCustomQuestionProps {
  order: number;
  onDelete: () => void;
}

export const DeleteCustomQuestion: FunctionComponent<
  DeleteCustomQuestionProps
> = ({ order, onDelete }) => {
  const { t } = useTranslations(translations);

  return (
    <Button tone="critical" variant="ghost" onClick={onDelete}>
      {t('custom.question.delete', {
        HiddenVisually: (children: ReactNode) => (
          <HiddenVisually>{children}</HiddenVisually>
        ),
        order: order.toString(),
      })}
    </Button>
  );
};
